import { Controller } from '@hotwired/stimulus'
import { DirectUpload } from '@rails/activestorage'

const csrfToken = document.getElementsByName('csrf-token')[0].content
let attachmentfiles = []
export default class MessagePreviewController extends Controller {
  static targets = ['input']

  connect() {
    this.quill = null
    this.element.addEventListener('submit', (e) => {
      e.preventDefault()
      this.submitMessageForm(this.element)
    })

    this.element.addEventListener('turbo:submit-start', (e) => {
      $(e.target).find('.chat-footer').addClass('disabled')
    })

    this.element.addEventListener('turbo:submit-end', (e) => {
      $(e.target).find('.chat-footer').removeClass('disabled')
      $(e.target)[0].reset()
      this.resetQuillInput(true)
      $('#attachment-previews').addClass('d-none')
      $('#audio-record-button').removeClass('disabled')
      $('#msgEmojiPicker').removeClass('disabled')
      $('#msgInputBox').removeClass('disabled')
      $('#messageAttachments').removeClass('disabled')
      $('#attachments_name').empty()
      $('.reply-msg').remove()
    })
  }

  resetQuillInput(focus = false) {
    const quillController =
      this.application.getControllerForElementAndIdentifier(
        this.element.querySelector("[data-controller='quill']"),
        'quill'
      )

    if (quillController) {
      quillController.clear()
      if (focus) {
        quillController.quill.focus()
      }
    }
  }

  selectFile(e, file = false) {
    const input = document.getElementById('message_attachments')
    const newFiles = file ? [file] : Array.from(e.target.files)

    // show alert when try to upload the more than 5 file
    if (attachmentfiles.length === 0 && newFiles.length > 5) {
      this.showAlert(
        'Attachment Limit Exceeded',
        'You can upload max 5 attachments',
        'error'
      )
      return
    }

    // validate total limit of file attachment
    if (attachmentfiles.length + newFiles.length > 5) {
      $('.show_error')
        .html('You can upload max 5 attachments')
        .addClass('text-danger')
      return
    }
    $('.show_error').html('')

    // store newly added files into attachment state
    attachmentfiles.push(...newFiles)

    // sync attachment state with actual input field
    const dt = new DataTransfer()
    attachmentfiles.forEach((f) => dt.items.add(f))
    input.files = dt.files

    $('#attachment-previews').removeClass('d-none')

    // display preview of new added files
    newFiles.forEach((file) => {
      const reader = new FileReader()
      this.createAndDisplayFilePreviewElements(file, reader)
    })
  }

  createAndDisplayFilePreviewElements(file, reader) {
    if (file.type.startsWith('audio/')) {
      const element = this.constructPreviews(file)
      element.classList.add('attachment-preview')
      document
        .getElementById('attachments_name')
        .insertBefore(
          element,
          document.getElementById('attachments_name').firstChild
        )
      return
    }

    reader.onload = () => {
      const element = this.constructPreviews(file, reader)
      element.classList.add('attachment-preview')
      document.getElementById('attachments_name').appendChild(element)
    }

    reader.readAsDataURL(file)
  }

  constructPreviews(file, reader) {
    let element
    let cancelFunction = (e) => this.removePreview(e)
    if (file.type.startsWith('audio/')) {
      const element = this.createAudioElement(cancelFunction, file)

      element.dataset.filename = file.name

      return element
    }

    switch (file.type) {
      case 'image/jpeg':
      case 'image/png':
      case 'image/webp':
      case 'image/gif':
        element = this.createImageElement(cancelFunction, reader)
        break
      case 'video/mp4':
      case 'video/quicktime':
        element = this.createVideoElement(cancelFunction, reader)
        break
      default:
        element = this.createDefaultElement(cancelFunction)
    }
    element.dataset.filename = file.name
    return element
  }

  createImageElement(cancelFunction, reader) {
    let cancelUploadButton, element
    const image = document.createElement('img')
    image.style = 'background-image: url(' + reader.result + ')'
    image.classList = 'bg-cover bg-center'
    image.classList.add('preview-image')
    element = document.createElement('div')
    element.classList.add('attachment-image-container', 'file-removal', 'position-relative')
    element.appendChild(image)
    cancelUploadButton = document.createElement('i')
    cancelUploadButton.classList.add(
      'ri-close-circle-line',
      'cancel-upload-button',
      'cursor-pointer',
      'position-absolute',
      'top-0',
      'end-0',
      'm-2',
      'text-danger',
      'fw-bolder',
      'fs-18',
      'lh-sm'
    )
    cancelUploadButton.onclick = cancelFunction
    element.appendChild(cancelUploadButton)
    return element
  }

  createVideoElement(cancelFunction, reader) {
    let cancelUploadButton, element
    const video = document.createElement('video')
    video.classList = 'bg-cover bg-center'
    video.setAttribute('controls', 'controls')
    video.src = reader.result
    video.classList.add('preview-video')
    element = document.createElement('div')
    element.classList.add('attachment-video-container', 'file-removal', 'position-relative')
    element.appendChild(video)
    cancelUploadButton = document.createElement('i')
    cancelUploadButton.classList.add(
      'ri-close-circle-line',
      'cancel-upload-button',
      'cursor-pointer',
      'position-absolute',
      'top-0',
      'end-0',
      'm-2',
      'text-danger',
      'fw-bolder',
      'fs-18',
      'lh-sm'
    )
    cancelUploadButton.onclick = cancelFunction
    element.appendChild(cancelUploadButton)
    return element
  }

  createAudioElement(cancelFunction, file) {
    const audioUrl = URL.createObjectURL(file)

    const wrapper = document.createElement('div')
    wrapper.dataset.controller = 'audio-player'
    wrapper.dataset.audioPlayerUrlValue = audioUrl

    wrapper.classList.add(
      'audio-preview',
      'attachment-audio-container',
      'file-removal',
      'position-relative',
      'attachment-audio-preview',
      'd-flex',
      'align-items-center',
      'justify-content-start',
      'gap-2',
      'rounded-3',
      'transparent-gradient',
      'p-2',
      'min-w-245px',
    )

    wrapper.innerHTML = `
      <button
        class="w-45px h-45px d-grid place-items-center cursor-pointer rounded-circle border-2 border-solid border-black bg-gradient-pink"
        data-action="audio-player#toggle"
        data-audio-player-target="playButton"
        type="button">
        <svg width="20" height="20" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="black" d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"/>
        </svg>
      </button>

      <div
        data-audio-player-target="waveform"
        class="audio-waveform flex-1 min-w-120px z-0">
      </div>
      <span
      class="text-white min-w-40px text-center"
        data-audio-player-target="duration">
        0:00
      </span>
    `

    this.audioObj = new Audio(audioUrl)

    return wrapper
  }

  removePreview(event) {
    const target = event.target.closest('.attachment-preview')
    const filename = target.dataset.filename

    // Remove the selected file from attachment state
    attachmentfiles = attachmentfiles.filter((file) => {
      return file.name !== filename
    })

    // Rebuild and sync input files after removing attachment
    const attachmentInput = document.getElementById('message_attachments')
    const dt = new DataTransfer()
    attachmentfiles.forEach((file) => {
      dt.items.add(file)
    })

    attachmentInput.files = dt.files

    target.remove()
    if (attachmentfiles.length === 0) {
      this.toggleVisibility()
    }
    $('#audio-record-button')?.removeClass('disabled')
  }

  submitMessageForm(element) {
    let button = this.element.querySelector('[type="button"]')
    let loader = this.element.querySelector('#sentLoader')
    button.classList.add('d-none')
    loader.classList.remove('d-none')
    let data = this.serializeForm(element)
    let params = {
      method: 'post',
      headers: {
        'X-CSRF-Token': csrfToken,
        Accept: 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml'
      }
    }
    params['body'] = data
    fetch(element.action, params)
      .then((r) => {
        if (r.redirected) {
          globalThis.location.href = r.url
        }
        return r.text()
      })
      .then((response) => {
        if (response.ok) {
          attachmentfiles = []
        }
        element.reset()
        attachmentfiles = []
        this.clearPreviews()
        this.clearReply()
        const messages = document.getElementById('chat-history')
        $('#audio-record-button').removeClass('disabled')
        $('#msgEmojiPicker').removeClass('disabled')
        $('#msgInputBox').removeClass('disabled')
        $('#messageAttachments').removeClass('disabled')
        $("[name='message[parent_id]']").remove()
        $('#attachments_name').empty()
        $('.reply-msg').remove()
        this.resetQuillInput(true)
        Turbo.renderStreamMessage(response)
        button.classList.remove('d-none')
        loader.classList.add('d-none')
        this?.quill?.quill?.setText('')
        setTimeout(() => {
          messages.scrollTop = messages.scrollHeight - messages.clientHeight
        }, 100)
      })
  }

  serializeForm = function (form) {
    let formData = new FormData(form)
    let files = attachmentfiles
    $.each(files, function (ind, val) {
      formData.append('message[attachments][]', val)
    })
    delete formData.attachments
    return formData
  }

  toggleVisibility() {
    let preview = document.getElementById('attachment-previews')
    preview.classList.toggle('d-none')
    $('#attachments_name').empty()
  }

  replyMessage(e) {
    e.preventDefault();
    const messageId = e.currentTarget?.dataset?.messageId;
    fetch(`/messages/${messageId}/reply`, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      }
    })
      .then((r) => r.json())
      .then(({ status, html_content }) => {
        if (!status) return;
        this.toggleReplyPreview(html_content || '')
      })
  }

  clearReply() {
    this.toggleReplyPreview();
  }

  toggleReplyPreview(content = '') {
    const preview = document.getElementById('reply-msg-previews');
    if (!preview) return;

    const contentBox = preview.querySelector('#reply-msg-content');
    if (!contentBox) return;

    const hasContent = content.trim().length > 0;
    preview.classList.toggle('d-none', !hasContent);
    contentBox.innerHTML = content;
  }

  clearPreviews() {
    let preview = document.getElementById('attachment-previews')
    preview.classList.add('d-none')
    $('#attachments_name').empty()
    $('#attachment-previews').addClass('d-none')
    $('#attachment-previews').removeClass('bottom-0')
    $('#attachment-previews')[0].style.setProperty('position', 'unset')
    $('.reply-msg').remove()
    $('#audio-record-button').removeClass('disabled')
    $('#msgEmojiPicker').removeClass('disabled')
    $('#msgInputBox').removeClass('disabled')
    $('#messageAttachments').removeClass('disabled')
    attachmentfiles = []
    const attachement = document.getElementById('message_attachments')
    if (attachement && attachement.files.length > 0) {
      attachement.value = '' // resets file selection on clear
    }
    $('.form-actions').removeClass('d-none')
    $('.audio-submit-btn').removeClass('d-none')
    if (this?.audioObj) {
      this.audioObj.pause()
      this.audioObj = null
      // URL.revokeObjectURL(this.audio.src)
    }
    $('#recorder').remove()
    const button = $('.message-submit-btn').clone()
    button.addClass('d-none')
    $('#attachments_name').html(button)
  }

  startAudio() {
    this.audio()
    this.clearPreviews()
    this.clearReply()
    $('#attachment-previews').removeClass('d-none')
    $('#attachment-previews').addClass('bottom-0')
    $('#attachment-previews')[0].style.setProperty(
      'position',
      'relative',
      'important'
    )
    $('.form-actions').addClass('d-none')
    $('.audio-submit-btn').addClass('d-none')
    $('#attachment-previews button')[0].classList.add('d-none')
    this.element.classList.add('disabled')
  }

  audio() {
    let record = document.getElementById('audio-record-button')
    let messageAttachments = document.getElementById('message_attachments')
    let recording = false
    if (navigator.mediaDevices.getUserMedia) {
      const constraints = { audio: true }
      let chunks = []
      let onSuccess = function (stream) {
        const audioTypes = ['audio/wav', 'audio/mp4', 'audio/mp3', 'audio/webm'];
        let audioType =  audioTypes.find(type => MediaRecorder.isTypeSupported(type)) ?? 'audio/webm';
        const mediaRecorder = new MediaRecorder(stream, {mimeType: audioType})
        startRecord(record, mediaRecorder)
        recording = !recording
        let stopRecordAudio = document.getElementById('stop-record')
        stopRecordAudio.onclick = function (event) {
          event.preventDefault()
          if (recording) {
            stopRecord(record, mediaRecorder)
            stream.getAudioTracks()[0].stop()
          } else {
            startRecord(record, mediaRecorder)
          }
          recording = !recording
        }
        mediaRecorder.onstop = function (event) {
          const blob = new Blob(chunks, { type: audioType })
          chunks = []
          let fileExtension = audioType.split('/')[1];
          if (fileExtension === 'ogg; codecs=opus') {
            fileExtension = 'ogg'; // Clean up for OGG codec
          }
          let file = new File([blob], 'audio-message.ogg', {
            type: audioType,
            lastModified: Date.now()
          })
          let container = new DataTransfer()
          container.items.clear()
          container.items.add(file)
          messageAttachments.files = container.files
          messageAttachments.dispatchEvent(new Event('change'))
          $('#not_ignore').val('')
          $('.audio-submit-btn').removeClass('d-none')
          $('.message-submit-btn').removeClass('d-none')
          $('#audio-record-button').removeClass('disabled')
          $('#messageAttachments').removeClass('disabled')
          $('#msgInputBox').removeClass('disabled')
          $('#msgEmojiPicker').removeClass('disabled')
        }
        mediaRecorder.ondataavailable = function (e) {
          chunks.push(e.data)
        }
      }
      let onError = function (err) {
        throwError(err)
      }
      navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError)
    }
  }

  submitIfValid(event) {
    $('#attachment-previews').addClass('d-none')
    const length = parseInt(this.inputTarget.dataset.length || 0, 10)
    if (
      length === 0 &&
      attachmentfiles.length === 0 &&
      event.currentTarget.dataset.type != 'submit' &&
      $('#attachment-previews .reply-msg').length == 0
    ) {
      event.preventDefault()
      return false
    }
    $('.form-actions').removeClass('d-none')
    $('.audio-submit-btn').removeClass('d-none')
  }

  removeLinkPreview(e) {
    const previewEle = e.target.closest('.preview-link')
    const linkThumb = previewEle.parentElement
    const urlEle = linkThumb.nextElementSibling
    urlEle.value = ''
    urlEle.nextElementSibling.value = false
    previewEle.remove()
  }

  showAlert(title, message, icon) {
    Swal.fire({
      customClass: {
        popup:
          'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      animation: false,
      title: title,
      text: message,
      icon: icon,
      confirmButtonText: 'OK'
    })
  }
}

const stopRecord = (record, mediaRecorder) => {
  mediaRecorder.stop()
  record.style.color = ''
  $(record)
    .find('i')
    .removeClass('fas text-primary')
    .addClass('far ri-play-fill')
  record.dataset.action = 'click->message-preview#startAudio'
  $('.timer').remove()
  $('#attachment-previews button')[0].classList.remove('d-none')
}

const startRecord = (record, mediaRecorder) => {
  $(record).find('i').addClass('fas text-primary').removeClass('far')
  let htmlContent = `
<div class="timer text-center d-flex align-items-center justify-content-between gap-3" id="recorder">
  <div class="d-flex align-items-center gap-3 transparent-gradient p-3 rounded-3">
    <div class="d-flex align-items-center gap-1">
      ${[1, 3, 5, 2, 2, 4, 1, 3, 5, 2, 2, 4, 1, 3, 5, 2]
        .map(
          (n) =>
            `<div class="audio-bar bg-white animated-bar rounded-5 bar-${n}"></div>`
        )
        .join('')}
    </div>
    <div class="text-white min-w-50px text-end">
      <span class="minutes text-white">00</span>
      <span class="text-white">:</span>
      <span class="seconds text-white">00</span>
    </div>
  </div>
  <button id="stop-record" class="btn border-2 border-solid border-black bg-gradient-pink">
    <i class="ri-stop-fill"></i> Stop
  </button>
</div>
`
  let preview = document.getElementById('attachment-previews')
  preview.classList.remove('d-none')
  preview.innerHTML += htmlContent
  mediaRecorder.start()
  record.dataset.action = ''
  timer()
}

const timer = () => {
  const minutes = document.querySelector('.minutes')
  const seconds = document.querySelector('.seconds')
  let timerTime = 0

  const incrementTimer = () => {
    timerTime++

    const numberMinutes = Math.floor(timerTime / 60)
    const numberSeconds = timerTime % 60

    minutes.innerText = pad(numberMinutes)
    seconds.innerText = pad(numberSeconds)
  }

  const pad = (number) => {
    return number < 10 ? '0' + number : number
  }

  setInterval(incrementTimer, 1000)
}

const uploadFile = (file) => {
  const input = document.getElementById('message_attachments')
  const url = input.dataset.directUploadUrl
  console.log(url)
  const upload = new DirectUpload(file, url)
  upload.create((error, blob) => {
    if (!error) {
      const hiddenField = document.createElement('input')
      hiddenField.dataset.type = 'hidden'
      hiddenField.dataset.value = blob.signed_id
      hiddenField.name = input.name
      let messageForm = document.getElementById('new_message')
      messageForm.appendChild(hiddenField)
    }
  })
}

function throwError(err) {
  let userMessage = ''

  switch (err.name) {
    case 'NotAllowedError':
      userMessage =
        'You denied microphone access. Please allow microphone access in your browser settings and reload the page.'
      break
    case 'PermissionDeniedError':
      userMessage =
        'Microphone permission was denied. Check your browser permissions.'
      break
    case 'NotFoundError':
      userMessage = 'No microphone found on your device.'
      break
    case 'NotReadableError':
      userMessage = 'Your microphone is in use by another application.'
      break
    case 'AbortError':
      userMessage = 'Could not access the microphone due to a system error.'
      break
    default:
      userMessage = 'Unable to access microphone. Please check your settings.'
  }
  alert(userMessage, 5000)
  if ($('#attachment-previews').find('.attachment-preview').length === 0)
    $('#attachment-previews').addClass('d-none')
  $('#audio-record-button').removeClass('disabled')
}
